import { Platform } from 'react-native';
import Constants from 'expo-constants';

export const DEV_BACKEND_PORT = 8000;

type ExpoConstantsWithLegacyManifest = typeof Constants & {
  manifest?: { debuggerHost?: string };
  manifest2?: { extra?: { expoGo?: { debuggerHost?: string } } };
};

/**
 * Extract the LAN/local host Expo uses to serve the JS bundle.
 * Works across SDK versions and falls back to null when unavailable.
 */
export function getExpoDevHost(): string | null {
  const constants = Constants as ExpoConstantsWithLegacyManifest;
  const host_uri =
    constants.expoConfig?.hostUri ??
    constants.manifest2?.extra?.expoGo?.debuggerHost ??
    constants.manifest?.debuggerHost;

  if (!host_uri) {
    return null;
  }

  const without_protocol = host_uri.replace(/^[a-z]+:\/\//, '');
  const host = without_protocol.split(':')[0]?.trim();
  return host || null;
}

/**
 * Resolve the backend API base URL for local development.
 * Prefers the current runtime host so network changes do not require .env edits.
 */
export function resolveDevApiBaseUrl(env_fallback?: string): string {
  if (Platform.OS === 'web') {
    if (typeof window !== 'undefined' && window.location?.hostname) {
      return `http://${window.location.hostname}:${DEV_BACKEND_PORT}`;
    }
    return env_fallback || `http://localhost:${DEV_BACKEND_PORT}`;
  }

  const expo_host = getExpoDevHost();
  if (expo_host) {
    return `http://${expo_host}:${DEV_BACKEND_PORT}`;
  }

  if (Platform.OS === 'android') {
    return `http://10.0.2.2:${DEV_BACKEND_PORT}`;
  }

  return env_fallback || `http://localhost:${DEV_BACKEND_PORT}`;
}

/**
 * Build a WebSocket URL from an HTTP API base URL and auth token.
 */
export function buildWebSocketUrl(api_base_url: string, token: string): string {
  const parsed = new URL(api_base_url);
  const protocol = parsed.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${parsed.host}/ws/?token=${token}`;
}
